import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import { SchedulesReportFilterOption } from "./OptionsMultiselectFilter";

export function buildScheduleTemplateOptions(
    templates: ScheduleTemplateListItem[],
): SchedulesReportFilterOption[] {
    return templates
        .map((template) => ({ id: template.id, label: template.name }))
        .sort((left, right) => left.label.localeCompare(right.label));
}

export function buildScheduleGroupOptions(
    templates: ScheduleTemplateListItem[],
): SchedulesReportFilterOption[] {
    return [...new Set(templates.map((template) => template.group))]
        .sort((left, right) => left.localeCompare(right))
        .map((group) => ({ id: group, label: group }));
}
